import { ChevronLeftIcon } from '@heroicons/react/24/outline'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'

const GoBack: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <div className="inline-flex items-center group cursor-pointer" onClick={onClick}>
      <ChevronLeftIcon className="w-5" />
      <div>{t.naw.survey.answer.navigation.back}</div>
    </div>
  )
}

export default GoBack
